import { Badge, Box, CircularProgress, Grid, IconButton, MenuItem, TextField, Tooltip, Typography } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import Modulgruppenfilter from "../Modulgruppenfilter/Modulgruppenfilter";
import { NextMonthButton, NextYearButton, PreviousMonthButton, PreviousYearButton } from "../NavigationButtons/NavigationButtons";
import { FullPageSpinner, SearchTextField, getMonthName } from "../lib";
import { useTranslation } from "react-i18next";
import { FilterList, GridOn, LegendToggle } from "@mui/icons-material";
import ResponsiveDialog from "../shared/components/ResponsiveDialog";
import { pad } from "../../functions/default";
import { useDebouncedCallback } from "use-debounce";
import InfiniteScrollWrapper from "./InfiniteScroll";
import { Legende } from "./Legende";
import { useZulassung } from "../../context/zulassungs-context";
import { useSessionStorage } from "../../utils/hooks";
import { LOCAL_STORAGE_KEY } from "../../constants/localStorage";
import axios from "axios";
import openFile from "../shared/functions/download";
import { useMessage } from "../../context/message-context";
import { API_BASE_URL } from "../../constants/apiConstants";
import { PageLayout } from "../shared/components/PageComponent";

function getDaysInMonth(month, year) {
  const date = new Date(year, month, 1);
  const days = [];
  while (date.getMonth() === month) {
    days.push(new Date(date));
    date.setDate(date.getDate() + 1);
  }
  const newMonth = date.getMonth();
  while (date.getMonth() === newMonth) {
    days.push(new Date(date));
    date.setDate(date.getDate() + 1);
  }
  return days;
}

function getDayText(day) {
  var daybez = "";
  if (day === 1) daybez = "Mo";
  if (day === 2) daybez = "Di";
  if (day === 3) daybez = "Mi";
  if (day === 4) daybez = "Do";
  if (day === 5) daybez = "Fr";
  if (day === 6) daybez = "Sa";
  if (day === 0) daybez = "So";
  return daybez;
}

function Monatskalender({
  modulGruppenFilter,
  onPreviousYearClick,
  onPreviousMonthClick,
  onNextMonthClick,
  onNextYearClick,
  month,
  year,
  isLoading,
  people,
  legende,
  showExcelExport,
  kkst,
  laks,
  gruppen,
  magruppen,
  admin,
  annonym,
  filter,
  setFilter,
  untergeben,
  setUntergeben,
}) {
  const [filterDialogOpen, setFilterDialogOpen] = useState(false);
  const [legendDialogOpen, setLegendDialogOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [gruppe, setGruppe] = useState("A");
  const [abrk, setAbrk] = useState(0);
  const [kst, setKst] = useState(0);
  const [firstRequest, setFirstRequest] = useState(true);
  const [accessToken] = useSessionStorage(LOCAL_STORAGE_KEY.accessToken);
  const { showErrorMessage } = useMessage();

  const { t } = useTranslation();
  const { zulassung } = useZulassung();
  const { mandant } = zulassung;

  const days = useMemo(() => {
    const tmpdays = getDaysInMonth(month, year);
    return tmpdays.map((element) => {
      var style = "";
      if ([0, 6].includes(element.getDay())) style = "weekend";
      return { key: getDayText(element.getDay()), style: style, date: element.getDate() };
    });
  }, [year, month]);

  const filteredPeople = useMemo(
    () =>
      people.filter((item, index) => {
        if (item.own === "J") return true;
        if (!item.name.toLowerCase().includes(filter?.toLowerCase())) return false;
        if (
          !admin &&
          !annonym &&
          untergeben &&
          untergeben !== "A" &&
          item.untergeben.includes(untergeben) === false &&
          item.mitglied.includes(untergeben) === false
        ) {
          return false;
        }
        if (!admin && !annonym && gruppe && gruppe !== "A" && item.gruppe.includes(gruppe) === false && item.mgruppe.includes(gruppe) === false) {
          return false;
        }
        if (!admin && !annonym && untergeben && untergeben === "M" && item.vgruppe.includes(gruppe) === true) {
          return false;
        }
        if (kst === 0 && abrk === 0) return true;
        if (kst !== 0) {
          if (item.kst.substr(0, 4) !== kkst[kst].key) return false;
        }
        if (abrk !== 0) {
          if (item.abrk.substr(0, 2) !== laks[abrk].key) return false;
        }
        return true;
      }),
    [people, untergeben, gruppe, kst, abrk, filter]
  );

  const handleFilterChange = useDebouncedCallback((event) => {
    localStorage.setItem("PMABWU_FILTER", event.target.value);
    setFilter(event.target.value);
  }, 500);

  function printInExcel() {
    setShowModal(true);

    const payload = {
      mandant: mandant,
      program: admin ? "PMABW2" : annonym ? "PMABW3" : "PMABWU",
      statement: "MONAT_EXCEL",
      users: people,
      legende: legende,
      monat: pad(month + 1, 2),
      jahr: year,
      anzahl: people.length,
      abrk: admin || annonym ? laks[abrk]?.name : "",
      kst: admin || annonym ? kkst[kst]?.name : "",
      abrkkey: admin || annonym ? laks[abrk]?.key : "",
      kstkey: admin || annonym ? kkst[kst]?.key : "",
      gruppe:
        location.hash.includes("/PMABWU") && gruppen && gruppen[gruppen.findIndex((e) => e.key === gruppe)]
          ? gruppen[gruppen.findIndex((e) => e.key === gruppe)].bez
          : "",
      untergeben:
        location.hash.includes("/PMABWU") && magruppen && magruppen[magruppen.findIndex((e) => e.key === untergeben)]
          ? magruppen[magruppen.findIndex((e) => e.key === untergeben)].bez
          : "",
      gruppekey: location.hash.includes("/PMABWU") ? gruppe : "",
      untergebenkey: location.hash.includes("/PMABWU") ? untergeben : "",
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
      Accept: "application/pdf",
    };
    axios
      .post(API_BASE_URL + "daten", payload, {
        headers: headers,
        responseType: "blob",
      })
      .then((response) => {
        var fileName = "Monatskalender_" + year + "_" + pad(month + 1, 2) + ".xlsx";
        var contentFile = response.data;
        const mimeType = response.headers["content-type"] || "application/pdf";
        openFile(fileName, contentFile, mimeType);
        closeModal();
      })
      .catch(function (error) {
        closeModal();
        showErrorMessage("Ein Fehler ist aufgetreten. Bitte versuchen Sie den download erneut.");
      });
  }
  const closeModal = () => {
    setShowModal(false);
  };

  const nextMonth = (checkMonth, checkYear) => {
    let newYear;
    let newMonth;
    if (checkMonth === 11) {
      newYear = checkYear + 1;
      newMonth = 0;
    } else {
      newYear = checkYear;
      newMonth = checkMonth + 1;
    }
    return newMonth;
  };

  const nextYear = (checkMonth, checkYear) => {
    let newYear;
    let newMonth;
    if (checkMonth === 11) {
      newYear = checkYear + 1;
      newMonth = 0;
    } else {
      newYear = checkYear;
      newMonth = checkMonth + 1;
    }
    return newYear;
  };

  const handleFilterOpen = () => {
    setFilterDialogOpen(true);
  };

  const handleLegendOpen = () => {
    setLegendDialogOpen(true);
  };

  return (
    <PageLayout
      header={
        <>
          <Box style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
            <PreviousYearButton onClick={onPreviousYearClick} />
            <PreviousMonthButton onClick={onPreviousMonthClick} />
            <Box style={{ flexGrow: 1 }}></Box>
            <Typography variant="body1">
              {t(getMonthName(month))} {year} - {getMonthName(nextMonth(month, year))} {nextYear(month, year)}
            </Typography>
            {isLoading ? <CircularProgress /> : <CircularProgress style={{ visibility: "hidden" }} />}
            <Box style={{ flexGrow: 1 }}></Box>
            <NextMonthButton onClick={onNextMonthClick} />
            <NextYearButton onClick={onNextYearClick} />
          </Box>
          <Box p={1} display="flex" alignItems={"center"}>
            <SearchTextField
              size="small"
              fullWidth
              label={t("Suche")}
              id="filter"
              variant="outlined"
              inputProps={{
                autoCapitalize: "off",
                autoCorrect: "off",
                spellCheck: "false",
                autoComplete: "off",
              }}
              onChange={handleFilterChange}
            />
            {showExcelExport && (
              <Box pl={1}>
                <Tooltip title={t("In Excel exportieren")}>
                  <IconButton color="primary" onClick={printInExcel}>
                    <GridOn />
                  </IconButton>
                </Tooltip>
              </Box>
            )}
            <Box pl={1}>
              <Tooltip title="Filter">
                <Badge
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  overlap="circular"
                  badgeContent={untergeben !== "A" || gruppe !== "A" || kst !== 0 || abrk !== 0 ? 1 : 0}
                  color="secondary"
                >
                  <IconButton color="primary" onClick={handleFilterOpen}>
                    <FilterList />
                  </IconButton>
                </Badge>
              </Tooltip>
            </Box>
            <Box pl={1}>
              <Tooltip title="Legende">
                <IconButton color="primary" onClick={handleLegendOpen}>
                  <LegendToggle />
                </IconButton>
              </Tooltip>
            </Box>
          </Box>
        </>
      }
      content={<InfiniteScrollWrapper items={filteredPeople} days={days} isLoading={isLoading} month={month} year={year} />}
      footer={
        <>
          {showModal && <FullPageSpinner />}
          <ResponsiveDialog open={legendDialogOpen} setOpen={setLegendDialogOpen} title="Legende">
            <Legende data={legende} />
          </ResponsiveDialog>
          <ResponsiveDialog open={filterDialogOpen} setOpen={setFilterDialogOpen} title="Filter">
            {modulGruppenFilter === "J" && (
              <Box p={1}>
                <Modulgruppenfilter
                  gruppen={gruppen}
                  small={true}
                  mitarbeiter={magruppen}
                  onMitarbeiterChange={setUntergeben}
                  onGruppeChange={setGruppe}
                  selectedGruppe={gruppe}
                  selectedMitarbeiter={untergeben}
                />
              </Box>
            )}
            {(admin || annonym) && (
              <Box p={2}>
                <Grid container justifyContent="center" spacing={2}>
                  <Grid item xs={12}>
                    <Typography>{t("Filter")}</Typography>
                  </Grid>
                  <Grid item xs={12} lg={6}>
                    <TextField
                      id="Abrechnungskreis"
                      label={t("Abrechnungskreis")}
                      select
                      size="small"
                      fullWidth
                      value={abrk}
                      onChange={(e) => {
                        setAbrk(e.target.value);
                      }}
                      variant="outlined"
                    >
                      {laks &&
                        laks.map((item, index) => (
                          <MenuItem key={index} value={index}>
                            {item.name}
                          </MenuItem>
                        ))}
                    </TextField>
                  </Grid>
                  <Grid item xs={12} lg={6}>
                    <TextField
                      id="Kostenstelle"
                      label={t("Kostenstelle")}
                      select
                      size="small"
                      fullWidth
                      value={kst}
                      onChange={(e) => {
                        setKst(e.target.value);
                      }}
                      variant="outlined"
                    >
                      {kkst &&
                        kkst.map((item, index) => (
                          <MenuItem key={index} value={index}>
                            {item.name}
                          </MenuItem>
                        ))}
                    </TextField>
                  </Grid>
                </Grid>
              </Box>
            )}
          </ResponsiveDialog>
        </>
      }
    />
  );
}

export default Monatskalender;
